import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    minHeight: "100vh",
    maxHeight: "fit-content",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  contentWrapper: {
    padding: "23px 16px",
  },
  tabs: {
    "& .mantine-Tabs-tabsList": {
      borderRadius: "8px",
      backgroundColor: "#FFF",
      padding: "16px 12px 02px 12px",
      border: "none",
      gap: 16,
      "& .mantine-Tabs-tab": {
        padding: "8px 16px",
        lineHeight: "20px",
        background: "#fff",
        borderRadius: "0px",
        color: "#737373",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 500,
        "&:hover": {
          borderColor: "none",
        },
        "&[data-active]": {
          color: "#262626 !important",
          backgroundColor: "#FFF !important",
          borderBottom: "2px solid #171717 !important",
        },
      }
    },
  },
}));

export default useStyles;
